import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M687-253v-454q0-17 12-28 11-12 28-12t28 12q12 11 12 28v454q0 17-12 28-11 12-28 12t-28-12q-12-11-12-28Zm-494-36v-382q0-18 12-29t28-11l12 2q6 2 11 6l275 190q9 6 14 15 4 8 4 18t-4 18q-5 9-14 15L256-257q-5 4-11 6l-12 2q-16 0-28-11t-12-29Zm80-191Zm0 115 167-115-167-115v230Z"/>',
  f: '<path d="M687-253v-454q0-17 12-28 11-12 28-12t28 12q12 11 12 28v454q0 17-12 28-11 12-28 12t-28-12q-12-11-12-28Zm-494-36v-382q0-18 12-29t28-11l12 2q6 2 11 6l275 190q9 6 14 15 4 8 4 18t-4 18q-5 9-14 15L256-257q-5 4-11 6l-12 2q-16 0-28-11t-12-29Z"/>',
};

export default data;
